/**
 * Utility functions for timezone handling across the application
 */

/**
 * Get the user's IANA timezone string
 * @returns {string} Timezone string like "America/New_York", "Europe/London", etc.
 */
export const getUserTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

/**
 * Get the user's timezone offset in minutes
 * @returns {number} Offset in minutes (e.g., -300 for EST)
 */
export const getUserTimezoneOffset = () => {
  return new Date().getTimezoneOffset();
};

/**
 * Get both timezone and offset
 * @returns {Object} { timezone: string, offset: number }
 */
export const getUserTimezoneInfo = () => {
  return {
    timezone: getUserTimezone(),
    offset: getUserTimezoneOffset()
  };
};
